import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			x1: "0%",
			x2: "0%",
			y1: "0%",
			y2: "100%",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: "0%",
				stopColor: "#fdfdfd"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: "100%",
				stopColor: "#f0f0f0"
			})]
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			width: 29,
			height: 29,
			x: 1.5,
			y: 1.5,
			fill: "url(#a)",
			stroke: "#c8c8c8",
			rx: 5,
			ry: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 26,
			x: 2.5,
			y: 2.5,
			fill: "none",
			stroke: "#fff",
			strokeWidth: .8,
			opacity: .9,
			rx: 4,
			ry: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "#6a6a6a",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.8,
			d: "M16 12v8m0 0 4-4m-4 4-4-4"
		})
	]
});
export default SvgKeyArrowDown;
